module.exports = __webpack_public_path__ + "static/media/Andy.78ce0f38.jpeg";